import { render, staticRenderFns } from "./MessengerIndicatorModule.vue?vue&type=template&id=7d8efd7f&scoped=true&"
import script from "./MessengerIndicatorModule.vue?vue&type=script&lang=js&"
export * from "./MessengerIndicatorModule.vue?vue&type=script&lang=js&"
import style0 from "./MessengerIndicatorModule.vue?vue&type=style&index=0&id=7d8efd7f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8efd7f",
  null
  
)

export default component.exports